<script lang="ts">
  import CloudflareImage from '../CloudflareImage.svelte';
  import type { IHero } from './Hero.svelte';

  export let hero: IHero;
</script>

<div class="bg-white">
  <div class="relative isolate overflow-hidden bg-gradient-to-b from-primary-100/20">
    <div
      class="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40"
    >
      <div class="px-6 lg:px-0 lg:pt-4">
        <div class="mx-auto max-w-2xl">
          <div class="max-w-lg">
            <h1 class="mt-10 text-4xl font-bold tracking-tight text-primary-500 sm:text-6xl">
              {hero.title}
            </h1>
            <p class="mt-6 text-lg leading-8 text-gray-600">{hero.text}</p>
            <div class="mt-10 flex items-center gap-x-6">
              {#each hero.buttons as btn, i}
                {#if i == 0}
                  <a
                    href={btn.href}
                    class="rounded-md bg-primary-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-400"
                  >
                    {btn.label}
                  </a>
                {:else}
                  <a href={btn.href} class="text-sm font-semibold leading-6 text-gray-900">
                    {btn.label} <span aria-hidden="true">→</span>
                  </a>
                {/if}
              {/each}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
        <div
          class="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-primary-600/10 ring-1 ring-primary-50 md:-mr-20 lg:-mr-36"
          aria-hidden="true"
        />
        <div class="shadow-lg md:rounded-3xl">
          <div
            class="bg-primary-500 [clip-path:inset(0)] md:[clip-path:inset(0_round_theme(borderRadius.3xl))]"
          >
            <div
              class="absolute -inset-y-px left-1/2 -z-10 ml-10 w-[200%] skew-x-[-30deg] bg-primary-100 opacity-20 ring-1 ring-inset ring-white md:ml-20 lg:ml-36"
              aria-hidden="true"
            />
            <div class="relative px-6 pt-8 sm:pt-16 md:pl-16 md:pr-0">
              <div class="mx-auto max-w-2xl md:mx-0 md:max-w-none">
                <div class="w-screen overflow-hidden rounded-tl-xl bg-gray-900">
                  <CloudflareImage src={hero.image} class="w-[38rem] h-96 object-cover" />
                </div>
              </div>
              <div
                class="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 md:rounded-3xl"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
  </div>
</div>
